module.exports = __webpack_public_path__ + "static/64-042fb23b00b6ab1e82926e1b80c57976.png";